export const ACTION_COMPLETE = 'complete';
export const ACTION_ENTRY = 'entry';
export const ACTION_FORGOT_PASSWORD_SELECTED = 'forgot password selected';
export const ACTION_LINK_EMAIL_SELECTED = 'link email selected';
export const ACTION_LINK_EMAIL_SUBMITTED = 'link email submited';
export const ACTION_RESEND_LOGIN_LINK_SELECTED = 'resend login link selected';
export const ACTION_VERIFICATION_FAILED_MODAL_DISPLAYED = 'verification failed modal displayed';
